/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Containers 

import React from 'react';
import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../../constants/resourceTypeConstants";
import {
	makeUserAccountSelector,
	makeUserAccountBalanceSelector,
	makeUserAccountBalanceSourceSelector,
	makeUserHistoryEntrySelector,
	makeBalanceChangeLogSelector,
	makeInternationalUserBankAccountSelector,
	makeUSDomesticUserBankAccountSelector,
	makeUserBankAccountDeltaSelector,
	makeUserAccountSettingsSelector,
	makeAdminGhostUserAccountSelector,
	makeUserAccountFinalizationSelector,
	makeThirdPartyUserAccountMappingSelector,
	makePreviousEmailAddressSelector,
	makePendingEmailChangeSelector,
	makeArchivedPendingEmailChangeSelector,
	makePasswordSelector,
	makeExpiredPasswordSelector,
	makePasswordResetSelector,
	makeDepositSelector,
	makeDepositInviteSelector,
	makeDepositAdjustmentSelector,
	makeDepositInterestSelector,
	makeDepositHistoryEntrySelector,
	makeDepositCloseRequestSelector,
	makeDepositUserStatsSelector,
	makeDepositBankMappingSelector,
	makeDepositBulkImportSelector,
	makeDepositInterestLogSelector,
	makeArchivedDepositCloseRequestSelector,
	makeDepositWithheldFundsSelector,
	makePMCReportTimetableSelector,
	makeDepositGroupSelector,
	makeDepositPostCloseAdjustmentSelector,
	makeDepositUserGroupSelector,
	makePropertyGroupSelector,
	makePropertyUserGroupSelector,
	makeDisputeSelector,
	makeDisputeSplitSelector,
	makeDisputeInterventionRequestSelector,
	makePropertySelector,
	makePropertyAddressSelector,
	makeComplianceSelector,
	makeComplianceRuleSelector,
	makeComplianceHistorySelector,
	makeEmailTemplateSelector,
	makeEmailVerificationSelector,
	makeEmailVerificationRecordSelector,
	makeEmailEventSelector,
	makeSentEmailSelector,
	makeMailboxSelector,
	makeMailboxMetaDataSelector,
	makeMailboxMessageSelector,
	makePermissionEntrySelector,
	makePermissionLogEntrySelector,
	makePermissionsOrganizationSettingsSelector,
	makeResourcePermissionSelector,
	makeOrganizationSelector,
	makeOrganizationResourcePermissionRuleSelector,
	makeInvoiceSelector,
	makeInvoiceItemSelector,
	makePaymentRequestSelector,
	makeStripePaymentLogSelector,
	makeUserWithdrawSelector,
	makePriorityACHPaymentSelector,
	makePriorityACHRecurringPaymentSelector,
	makeLoanApplicationSelector,
	makeLoanSystemInfoSelector,
	makeLoanSelector,
	makeLoanHistorySelector,
	makeLoanPaymentLogSelector,
	makeStripeWebhookLogSelector,
	makeUserAccountPaymentProviderInfoSelector,
	makeSezzleOrderSelector,
	makeSezzleWebhookEventSelector,
	makeBankAccountSelector,
	makeBankAccountHistoricalInterestRateSelector,
	makeBankAccountInterestSelector,
	makeBankAccountBalanceRecordSelector,
	makeBankTransferSelector,
	makeBulkFundsTransferSelector,
	makeFundsLockSelector,
	makeFundsLockReleaseLogSelector,
	makeReleasedFundsLockSelector,
	makeBalanceSourceTransferSelector,
	makeCreditUserAccountLogSelector,
	makeEventSelector,
	makeEventHookSelector,
	makeNotificationSelector,
	makeActionItemSelector,
	makeUpdateLogSelector,
	makeStorageFileSelector,
	makeAttachedStorageFilesSelector,
	makeSystemHistoryEntrySelector,
	makeSnapshotSelector,
	makeIPAddressSelector,
	makeKnownIPAddressSelector,
	makeUserAgentSelector,
	makeKnownUserAgentSelector,
	makeSystemStatsSelector,
	makeResourceNoteSelector,
	makeDeposifyTagSelector,
	makePermanentLinkSelector,
	makeOnlineUserSelector,
	makeFrontendGeneralSettingsSelector,
	makeYardiScreeningWorksProXMLSelector,
	makeYardiVoyagerXMLSelector,
	makeYardiVoyagerTransactionSelector,
	makeYardiVoyagerResidentSelector,
	makeYardiVoyagerResidentCustomColumnSelector,
	makeYardiVoyagerPropertyUnitSelector,
	makeYardiVoyagerPropertySelector,
	makeYardiVoyagerPMCServiceInterfaceVersionSelector,
	makeYardiVoyagerPMCSelector,
	makeYardiVoyagerPMCCredentialsSelector,
	makeYardiVoyagerPetSelector,
	makeYardiVoyagerILSGuestCardEventSelector,
	makeYardiVoyagerChargeSelector,
	makeYardiVoyagerChargeCodeSelector,
	makeYardiVoyagerDepositCreateIntentSelector,
	makeYardiVoyagerDepositCloseIntentSelector,
	makeYardiVoyagerDepositWithholdIntentSelector,
	makeYardiVoyagerEventSelector,
	makeYardiVoyagerFlexDepositIntentSelector,
	makeYardiVoyagerPhoneSelector,
	makeYardiVoyagerOtherOccupantSelector,
	makeYardiVoyagerPMCCustomColumnSettingsSelector,
	makeYardiVoyagerPMCStatsSelector,
	makeYardiVoyagerPMCStatsCollectorSelector,
	makeYardiVoyagerActiveScanLogEntrySelector,
	makeYardiVoyagerSystemSettingsSelector}
from "../../selectors/resourceSelectors";
import {
	loadingActionLoadUserAccountFromServer,
	loadingActionLoadUserAccountBalanceFromServer,
	loadingActionLoadUserAccountBalanceSourceFromServer,
	loadingActionLoadUserHistoryEntryFromServer,
	loadingActionLoadBalanceChangeLogFromServer,
	loadingActionLoadInternationalUserBankAccountFromServer,
	loadingActionLoadUSDomesticUserBankAccountFromServer,
	loadingActionLoadUserBankAccountDeltaFromServer,
	loadingActionLoadUserAccountSettingsFromServer,
	loadingActionLoadAdminGhostUserAccountFromServer,
	loadingActionLoadUserAccountFinalizationFromServer,
	loadingActionLoadThirdPartyUserAccountMappingFromServer,
	loadingActionLoadPreviousEmailAddressFromServer,
	loadingActionLoadPendingEmailChangeFromServer,
	loadingActionLoadArchivedPendingEmailChangeFromServer,
	loadingActionLoadPasswordFromServer,
	loadingActionLoadExpiredPasswordFromServer,
	loadingActionLoadPasswordResetFromServer,
	loadingActionLoadDepositFromServer,
	loadingActionLoadDepositInviteFromServer,
	loadingActionLoadDepositAdjustmentFromServer,
	loadingActionLoadDepositInterestFromServer,
	loadingActionLoadDepositHistoryEntryFromServer,
	loadingActionLoadDepositCloseRequestFromServer,
	loadingActionLoadDepositUserStatsFromServer,
	loadingActionLoadDepositBankMappingFromServer,
	loadingActionLoadDepositBulkImportFromServer,
	loadingActionLoadDepositInterestLogFromServer,
	loadingActionLoadArchivedDepositCloseRequestFromServer,
	loadingActionLoadDepositWithheldFundsFromServer,
	loadingActionLoadPMCReportTimetableFromServer,
	loadingActionLoadDepositGroupFromServer,
	loadingActionLoadDepositPostCloseAdjustmentFromServer,
	loadingActionLoadDepositUserGroupFromServer,
	loadingActionLoadPropertyGroupFromServer,
	loadingActionLoadPropertyUserGroupFromServer,
	loadingActionLoadDisputeFromServer,
	loadingActionLoadDisputeSplitFromServer,
	loadingActionLoadDisputeInterventionRequestFromServer,
	loadingActionLoadPropertyFromServer,
	loadingActionLoadPropertyAddressFromServer,
	loadingActionLoadComplianceFromServer,
	loadingActionLoadComplianceRuleFromServer,
	loadingActionLoadComplianceHistoryFromServer,
	loadingActionLoadEmailTemplateFromServer,
	loadingActionLoadEmailVerificationFromServer,
	loadingActionLoadEmailVerificationRecordFromServer,
	loadingActionLoadEmailEventFromServer,
	loadingActionLoadSentEmailFromServer,
	loadingActionLoadMailboxFromServer,
	loadingActionLoadMailboxMetaDataFromServer,
	loadingActionLoadMailboxMessageFromServer,
	loadingActionLoadPermissionEntryFromServer,
	loadingActionLoadPermissionLogEntryFromServer,
	loadingActionLoadPermissionsOrganizationSettingsFromServer,
	loadingActionLoadResourcePermissionFromServer,
	loadingActionLoadOrganizationFromServer,
	loadingActionLoadOrganizationResourcePermissionRuleFromServer,
	loadingActionLoadInvoiceFromServer,
	loadingActionLoadInvoiceItemFromServer,
	loadingActionLoadPaymentRequestFromServer,
	loadingActionLoadStripePaymentLogFromServer,
	loadingActionLoadUserWithdrawFromServer,
	loadingActionLoadPriorityACHPaymentFromServer,
	loadingActionLoadPriorityACHRecurringPaymentFromServer,
	loadingActionLoadLoanApplicationFromServer,
	loadingActionLoadLoanSystemInfoFromServer,
	loadingActionLoadLoanFromServer,
	loadingActionLoadLoanHistoryFromServer,
	loadingActionLoadLoanPaymentLogFromServer,
	loadingActionLoadStripeWebhookLogFromServer,
	loadingActionLoadUserAccountPaymentProviderInfoFromServer,
	loadingActionLoadSezzleOrderFromServer,
	loadingActionLoadSezzleWebhookEventFromServer,
	loadingActionLoadBankAccountFromServer,
	loadingActionLoadBankAccountHistoricalInterestRateFromServer,
	loadingActionLoadBankAccountInterestFromServer,
	loadingActionLoadBankAccountBalanceRecordFromServer,
	loadingActionLoadBankTransferFromServer,
	loadingActionLoadBulkFundsTransferFromServer,
	loadingActionLoadFundsLockFromServer,
	loadingActionLoadFundsLockReleaseLogFromServer,
	loadingActionLoadReleasedFundsLockFromServer,
	loadingActionLoadBalanceSourceTransferFromServer,
	loadingActionLoadCreditUserAccountLogFromServer,
	loadingActionLoadEventFromServer,
	loadingActionLoadEventHookFromServer,
	loadingActionLoadNotificationFromServer,
	loadingActionLoadActionItemFromServer,
	loadingActionLoadUpdateLogFromServer,
	loadingActionLoadStorageFileFromServer,
	loadingActionLoadAttachedStorageFilesFromServer,
	loadingActionLoadSystemHistoryEntryFromServer,
	loadingActionLoadSnapshotFromServer,
	loadingActionLoadIPAddressFromServer,
	loadingActionLoadKnownIPAddressFromServer,
	loadingActionLoadUserAgentFromServer,
	loadingActionLoadKnownUserAgentFromServer,
	loadingActionLoadSystemStatsFromServer,
	loadingActionLoadResourceNoteFromServer,
	loadingActionLoadDeposifyTagFromServer,
	loadingActionLoadPermanentLinkFromServer,
	loadingActionLoadOnlineUserFromServer,
	loadingActionLoadFrontendGeneralSettingsFromServer,
	loadingActionLoadYardiScreeningWorksProXMLFromServer,
	loadingActionLoadYardiVoyagerXMLFromServer,
	loadingActionLoadYardiVoyagerTransactionFromServer,
	loadingActionLoadYardiVoyagerResidentFromServer,
	loadingActionLoadYardiVoyagerResidentCustomColumnFromServer,
	loadingActionLoadYardiVoyagerPropertyUnitFromServer,
	loadingActionLoadYardiVoyagerPropertyFromServer,
	loadingActionLoadYardiVoyagerPMCServiceInterfaceVersionFromServer,
	loadingActionLoadYardiVoyagerPMCFromServer,
	loadingActionLoadYardiVoyagerPMCCredentialsFromServer,
	loadingActionLoadYardiVoyagerPetFromServer,
	loadingActionLoadYardiVoyagerILSGuestCardEventFromServer,
	loadingActionLoadYardiVoyagerChargeFromServer,
	loadingActionLoadYardiVoyagerChargeCodeFromServer,
	loadingActionLoadYardiVoyagerDepositCreateIntentFromServer,
	loadingActionLoadYardiVoyagerDepositCloseIntentFromServer,
	loadingActionLoadYardiVoyagerDepositWithholdIntentFromServer,
	loadingActionLoadYardiVoyagerEventFromServer,
	loadingActionLoadYardiVoyagerFlexDepositIntentFromServer,
	loadingActionLoadYardiVoyagerPhoneFromServer,
	loadingActionLoadYardiVoyagerOtherOccupantFromServer,
	loadingActionLoadYardiVoyagerPMCCustomColumnSettingsFromServer,
	loadingActionLoadYardiVoyagerPMCStatsFromServer,
	loadingActionLoadYardiVoyagerPMCStatsCollectorFromServer,
	loadingActionLoadYardiVoyagerActiveScanLogEntryFromServer,
	loadingActionLoadYardiVoyagerSystemSettingsFromServer}
from "../../actions/resourceLoadingActions";
import GenericContainer from "../../../clientShared/components/containers/GenericContainer";

export function UserAccountContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT}
			makeResourceSelector={makeUserAccountSelector}
			serverLoadingFunction={loadingActionLoadUserAccountFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserAccountBalanceContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_BALANCE}
			makeResourceSelector={makeUserAccountBalanceSelector}
			serverLoadingFunction={loadingActionLoadUserAccountBalanceFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserAccountBalanceSourceContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.sourceUID}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE}
			makeResourceSelector={makeUserAccountBalanceSourceSelector}
			serverLoadingFunction={loadingActionLoadUserAccountBalanceSourceFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserHistoryEntryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.entryUID}
			resourceType={RESOURCE_TYPE_USER_HISTORY_ENTRY}
			makeResourceSelector={makeUserHistoryEntrySelector}
			serverLoadingFunction={loadingActionLoadUserHistoryEntryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BalanceChangeLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.changeLogUID}
			resourceType={RESOURCE_TYPE_BALANCE_CHANGE_LOG}
			makeResourceSelector={makeBalanceChangeLogSelector}
			serverLoadingFunction={loadingActionLoadBalanceChangeLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function InternationalUserBankAccountContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.bankAccountUID}
			resourceType={RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT}
			makeResourceSelector={makeInternationalUserBankAccountSelector}
			serverLoadingFunction={loadingActionLoadInternationalUserBankAccountFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function USDomesticUserBankAccountContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.bankAccountUID}
			resourceType={RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT}
			makeResourceSelector={makeUSDomesticUserBankAccountSelector}
			serverLoadingFunction={loadingActionLoadUSDomesticUserBankAccountFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserBankAccountDeltaContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.deltaUID}
			resourceType={RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA}
			makeResourceSelector={makeUserBankAccountDeltaSelector}
			serverLoadingFunction={loadingActionLoadUserBankAccountDeltaFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserAccountSettingsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_SETTINGS}
			makeResourceSelector={makeUserAccountSettingsSelector}
			serverLoadingFunction={loadingActionLoadUserAccountSettingsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function AdminGhostUserAccountContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.ghostAccountUID}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST}
			makeResourceSelector={makeAdminGhostUserAccountSelector}
			serverLoadingFunction={loadingActionLoadAdminGhostUserAccountFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserAccountFinalizationContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION}
			makeResourceSelector={makeUserAccountFinalizationSelector}
			serverLoadingFunction={loadingActionLoadUserAccountFinalizationFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ThirdPartyUserAccountMappingContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING}
			makeResourceSelector={makeThirdPartyUserAccountMappingSelector}
			serverLoadingFunction={loadingActionLoadThirdPartyUserAccountMappingFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PreviousEmailAddressContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.previousEmailUID}
			resourceType={RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS}
			makeResourceSelector={makePreviousEmailAddressSelector}
			serverLoadingFunction={loadingActionLoadPreviousEmailAddressFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PendingEmailChangeContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.changeUID}
			resourceType={RESOURCE_TYPE_PENDING_EMAIL_CHANGE}
			makeResourceSelector={makePendingEmailChangeSelector}
			serverLoadingFunction={loadingActionLoadPendingEmailChangeFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ArchivedPendingEmailChangeContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.changeUID}
			resourceType={RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE}
			makeResourceSelector={makeArchivedPendingEmailChangeSelector}
			serverLoadingFunction={loadingActionLoadArchivedPendingEmailChangeFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PasswordContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_PASSWORD}
			makeResourceSelector={makePasswordSelector}
			serverLoadingFunction={loadingActionLoadPasswordFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ExpiredPasswordContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.expiredPasswordUID}
			resourceType={RESOURCE_TYPE_EXPIRED_PASSWORD}
			makeResourceSelector={makeExpiredPasswordSelector}
			serverLoadingFunction={loadingActionLoadExpiredPasswordFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PasswordResetContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.resetUID}
			resourceType={RESOURCE_TYPE_PASSWORD_RESET}
			makeResourceSelector={makePasswordResetSelector}
			serverLoadingFunction={loadingActionLoadPasswordResetFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.depositUID}
			resourceType={RESOURCE_TYPE_DEPOSIT}
			makeResourceSelector={makeDepositSelector}
			serverLoadingFunction={loadingActionLoadDepositFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositInviteContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.depositUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_INVITE}
			makeResourceSelector={makeDepositInviteSelector}
			serverLoadingFunction={loadingActionLoadDepositInviteFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositAdjustmentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.adjustmentUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_ADJUSTMENT}
			makeResourceSelector={makeDepositAdjustmentSelector}
			serverLoadingFunction={loadingActionLoadDepositAdjustmentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositInterestContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.interestUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_INTEREST}
			makeResourceSelector={makeDepositInterestSelector}
			serverLoadingFunction={loadingActionLoadDepositInterestFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositHistoryEntryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.entryUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY}
			makeResourceSelector={makeDepositHistoryEntrySelector}
			serverLoadingFunction={loadingActionLoadDepositHistoryEntryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositCloseRequestContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.depositUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST}
			makeResourceSelector={makeDepositCloseRequestSelector}
			serverLoadingFunction={loadingActionLoadDepositCloseRequestFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositUserStatsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_USER_STATS}
			makeResourceSelector={makeDepositUserStatsSelector}
			serverLoadingFunction={loadingActionLoadDepositUserStatsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositBankMappingContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.mapUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_BANK_MAPPING}
			makeResourceSelector={makeDepositBankMappingSelector}
			serverLoadingFunction={loadingActionLoadDepositBankMappingFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositBulkImportContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.bulkImportUID}
			resourceType={RESOURCE_TYPE_DEPOSITS_BULK_IMPORT}
			makeResourceSelector={makeDepositBulkImportSelector}
			serverLoadingFunction={loadingActionLoadDepositBulkImportFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositInterestLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.entryUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_INTEREST_LOG}
			makeResourceSelector={makeDepositInterestLogSelector}
			serverLoadingFunction={loadingActionLoadDepositInterestLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ArchivedDepositCloseRequestContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.archiveUID}
			resourceType={RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST}
			makeResourceSelector={makeArchivedDepositCloseRequestSelector}
			serverLoadingFunction={loadingActionLoadArchivedDepositCloseRequestFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositWithheldFundsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.withheldUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS}
			makeResourceSelector={makeDepositWithheldFundsSelector}
			serverLoadingFunction={loadingActionLoadDepositWithheldFundsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PMCReportTimetableContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.timetableUID}
			resourceType={RESOURCE_TYPE_PMC_REPORT_TIMETABLE}
			makeResourceSelector={makePMCReportTimetableSelector}
			serverLoadingFunction={loadingActionLoadPMCReportTimetableFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositGroupContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.groupUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_GROUP}
			makeResourceSelector={makeDepositGroupSelector}
			serverLoadingFunction={loadingActionLoadDepositGroupFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositPostCloseAdjustmentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.adjustmentUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT}
			makeResourceSelector={makeDepositPostCloseAdjustmentSelector}
			serverLoadingFunction={loadingActionLoadDepositPostCloseAdjustmentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DepositUserGroupContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.depositUID}
			resourceType={RESOURCE_TYPE_DEPOSIT_USER_GROUP}
			makeResourceSelector={makeDepositUserGroupSelector}
			serverLoadingFunction={loadingActionLoadDepositUserGroupFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PropertyGroupContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.groupUID}
			resourceType={RESOURCE_TYPE_PROPERTY_GROUP}
			makeResourceSelector={makePropertyGroupSelector}
			serverLoadingFunction={loadingActionLoadPropertyGroupFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PropertyUserGroupContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.propertyUID}
			resourceType={RESOURCE_TYPE_PROPERTY_USER_GROUP}
			makeResourceSelector={makePropertyUserGroupSelector}
			serverLoadingFunction={loadingActionLoadPropertyUserGroupFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DisputeContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.disputeUID}
			resourceType={RESOURCE_TYPE_DISPUTE}
			makeResourceSelector={makeDisputeSelector}
			serverLoadingFunction={loadingActionLoadDisputeFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DisputeSplitContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.splitUID}
			resourceType={RESOURCE_TYPE_DISPUTE_SPLIT}
			makeResourceSelector={makeDisputeSplitSelector}
			serverLoadingFunction={loadingActionLoadDisputeSplitFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DisputeInterventionRequestContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.requestUID}
			resourceType={RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST}
			makeResourceSelector={makeDisputeInterventionRequestSelector}
			serverLoadingFunction={loadingActionLoadDisputeInterventionRequestFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PropertyContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.propertyUID}
			resourceType={RESOURCE_TYPE_PROPERTY}
			makeResourceSelector={makePropertySelector}
			serverLoadingFunction={loadingActionLoadPropertyFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PropertyAddressContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.propertyAddressUID}
			resourceType={RESOURCE_TYPE_PROPERTY_ADDRESS}
			makeResourceSelector={makePropertyAddressSelector}
			serverLoadingFunction={loadingActionLoadPropertyAddressFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ComplianceContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.complianceUID}
			resourceType={RESOURCE_TYPE_COMPLIANCE}
			makeResourceSelector={makeComplianceSelector}
			serverLoadingFunction={loadingActionLoadComplianceFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ComplianceRuleContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.complianceRuleUID}
			resourceType={RESOURCE_TYPE_COMPLIANCE_RULE}
			makeResourceSelector={makeComplianceRuleSelector}
			serverLoadingFunction={loadingActionLoadComplianceRuleFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ComplianceHistoryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.complianceHistoryUID}
			resourceType={RESOURCE_TYPE_COMPLIANCE_HISTORY}
			makeResourceSelector={makeComplianceHistorySelector}
			serverLoadingFunction={loadingActionLoadComplianceHistoryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function EmailTemplateContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.templateUID}
			resourceType={RESOURCE_TYPE_EMAIL_TEMPLATE}
			makeResourceSelector={makeEmailTemplateSelector}
			serverLoadingFunction={loadingActionLoadEmailTemplateFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function EmailVerificationContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.verificationUID}
			resourceType={RESOURCE_TYPE_EMAIL_VERIFICATION}
			makeResourceSelector={makeEmailVerificationSelector}
			serverLoadingFunction={loadingActionLoadEmailVerificationFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function EmailVerificationRecordContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.verificationUID}
			resourceType={RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD}
			makeResourceSelector={makeEmailVerificationRecordSelector}
			serverLoadingFunction={loadingActionLoadEmailVerificationRecordFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function EmailEventContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.eventUID}
			resourceType={RESOURCE_TYPE_EMAIL_EVENT}
			makeResourceSelector={makeEmailEventSelector}
			serverLoadingFunction={loadingActionLoadEmailEventFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function SentEmailContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.emailUID}
			resourceType={RESOURCE_TYPE_SENT_EMAIL}
			makeResourceSelector={makeSentEmailSelector}
			serverLoadingFunction={loadingActionLoadSentEmailFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function MailboxContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.mailboxUID}
			resourceType={RESOURCE_TYPE_MAILBOX}
			makeResourceSelector={makeMailboxSelector}
			serverLoadingFunction={loadingActionLoadMailboxFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function MailboxMetaDataContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.metaDataUID}
			resourceType={RESOURCE_TYPE_MAILBOX_META_DATA}
			makeResourceSelector={makeMailboxMetaDataSelector}
			serverLoadingFunction={loadingActionLoadMailboxMetaDataFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function MailboxMessageContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.messageUID}
			resourceType={RESOURCE_TYPE_MAILBOX_MESSAGE}
			makeResourceSelector={makeMailboxMessageSelector}
			serverLoadingFunction={loadingActionLoadMailboxMessageFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PermissionEntryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.permissionUID}
			resourceType={RESOURCE_TYPE_PERMISSION_ENTRY}
			makeResourceSelector={makePermissionEntrySelector}
			serverLoadingFunction={loadingActionLoadPermissionEntryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PermissionLogEntryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.logEntryUID}
			resourceType={RESOURCE_TYPE_PERMISSION_LOG_ENTRY}
			makeResourceSelector={makePermissionLogEntrySelector}
			serverLoadingFunction={loadingActionLoadPermissionLogEntryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PermissionsOrganizationSettingsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.organizationUID}
			resourceType={RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS}
			makeResourceSelector={makePermissionsOrganizationSettingsSelector}
			serverLoadingFunction={loadingActionLoadPermissionsOrganizationSettingsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ResourcePermissionContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.permissionUID}
			resourceType={RESOURCE_TYPE_RESOURCE_PERMISSIONS}
			makeResourceSelector={makeResourcePermissionSelector}
			serverLoadingFunction={loadingActionLoadResourcePermissionFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function OrganizationContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.organizationUID}
			resourceType={RESOURCE_TYPE_ORGANIZATION}
			makeResourceSelector={makeOrganizationSelector}
			serverLoadingFunction={loadingActionLoadOrganizationFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function OrganizationResourcePermissionRuleContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.ruleUID}
			resourceType={RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE}
			makeResourceSelector={makeOrganizationResourcePermissionRuleSelector}
			serverLoadingFunction={loadingActionLoadOrganizationResourcePermissionRuleFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function InvoiceContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.invoiceUID}
			resourceType={RESOURCE_TYPE_INVOICE}
			makeResourceSelector={makeInvoiceSelector}
			serverLoadingFunction={loadingActionLoadInvoiceFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function InvoiceItemContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.invoiceItemUID}
			resourceType={RESOURCE_TYPE_INVOICE_ITEM}
			makeResourceSelector={makeInvoiceItemSelector}
			serverLoadingFunction={loadingActionLoadInvoiceItemFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PaymentRequestContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.requestUID}
			resourceType={RESOURCE_TYPE_PAYMENT_REQUEST}
			makeResourceSelector={makePaymentRequestSelector}
			serverLoadingFunction={loadingActionLoadPaymentRequestFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function StripePaymentLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.paymentLogUID}
			resourceType={RESOURCE_TYPE_STRIPE_PAYMENT_LOG}
			makeResourceSelector={makeStripePaymentLogSelector}
			serverLoadingFunction={loadingActionLoadStripePaymentLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserWithdrawContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.withdrawUID}
			resourceType={RESOURCE_TYPE_USER_WITHDRAW}
			makeResourceSelector={makeUserWithdrawSelector}
			serverLoadingFunction={loadingActionLoadUserWithdrawFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PriorityACHPaymentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.paymentUID}
			resourceType={RESOURCE_TYPE_PRIORITY_ACH_PAYMENT}
			makeResourceSelector={makePriorityACHPaymentSelector}
			serverLoadingFunction={loadingActionLoadPriorityACHPaymentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PriorityACHRecurringPaymentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.recurringPaymentUID}
			resourceType={RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT}
			makeResourceSelector={makePriorityACHRecurringPaymentSelector}
			serverLoadingFunction={loadingActionLoadPriorityACHRecurringPaymentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function LoanApplicationContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.applicationUID}
			resourceType={RESOURCE_TYPE_LOAN_APPLICATION}
			makeResourceSelector={makeLoanApplicationSelector}
			serverLoadingFunction={loadingActionLoadLoanApplicationFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function LoanSystemInfoContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.loanInfoUID}
			resourceType={RESOURCE_TYPE_LOAN_SYSTEM_INFO}
			makeResourceSelector={makeLoanSystemInfoSelector}
			serverLoadingFunction={loadingActionLoadLoanSystemInfoFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function LoanContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.loanUID}
			resourceType={RESOURCE_TYPE_LOAN}
			makeResourceSelector={makeLoanSelector}
			serverLoadingFunction={loadingActionLoadLoanFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function LoanHistoryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.loanUID}
			resourceType={RESOURCE_TYPE_LOAN_HISTORY}
			makeResourceSelector={makeLoanHistorySelector}
			serverLoadingFunction={loadingActionLoadLoanHistoryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function LoanPaymentLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.logUID}
			resourceType={RESOURCE_TYPE_LOAN_PAYMENT_LOG}
			makeResourceSelector={makeLoanPaymentLogSelector}
			serverLoadingFunction={loadingActionLoadLoanPaymentLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function StripeWebhookLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.logUID}
			resourceType={RESOURCE_TYPE_STRIPE_WEBHOOK_LOG}
			makeResourceSelector={makeStripeWebhookLogSelector}
			serverLoadingFunction={loadingActionLoadStripeWebhookLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserAccountPaymentProviderInfoContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.accountUID}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO}
			makeResourceSelector={makeUserAccountPaymentProviderInfoSelector}
			serverLoadingFunction={loadingActionLoadUserAccountPaymentProviderInfoFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function SezzleOrderContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.sezzleOrderUID}
			resourceType={RESOURCE_TYPE_SEZZLE_ORDER}
			makeResourceSelector={makeSezzleOrderSelector}
			serverLoadingFunction={loadingActionLoadSezzleOrderFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function SezzleWebhookEventContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.eventUID}
			resourceType={RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT}
			makeResourceSelector={makeSezzleWebhookEventSelector}
			serverLoadingFunction={loadingActionLoadSezzleWebhookEventFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BankAccountContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.bankAccountUID}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT}
			makeResourceSelector={makeBankAccountSelector}
			serverLoadingFunction={loadingActionLoadBankAccountFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BankAccountHistoricalInterestRateContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.rateHistoryUID}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE}
			makeResourceSelector={makeBankAccountHistoricalInterestRateSelector}
			serverLoadingFunction={loadingActionLoadBankAccountHistoricalInterestRateFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BankAccountInterestContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.interestUID}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_INTEREST}
			makeResourceSelector={makeBankAccountInterestSelector}
			serverLoadingFunction={loadingActionLoadBankAccountInterestFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BankAccountBalanceRecordContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.recordUID}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD}
			makeResourceSelector={makeBankAccountBalanceRecordSelector}
			serverLoadingFunction={loadingActionLoadBankAccountBalanceRecordFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BankTransferContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.transferUID}
			resourceType={RESOURCE_TYPE_BANK_TRANSFER}
			makeResourceSelector={makeBankTransferSelector}
			serverLoadingFunction={loadingActionLoadBankTransferFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BulkFundsTransferContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.bulkTransferUID}
			resourceType={RESOURCE_TYPE_BULK_FUNDS_TRANSFER}
			makeResourceSelector={makeBulkFundsTransferSelector}
			serverLoadingFunction={loadingActionLoadBulkFundsTransferFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function FundsLockContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.lockUID}
			resourceType={RESOURCE_TYPE_FUNDS_LOCK}
			makeResourceSelector={makeFundsLockSelector}
			serverLoadingFunction={loadingActionLoadFundsLockFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function FundsLockReleaseLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.releaseLogUID}
			resourceType={RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG}
			makeResourceSelector={makeFundsLockReleaseLogSelector}
			serverLoadingFunction={loadingActionLoadFundsLockReleaseLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ReleasedFundsLockContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.lockUID}
			resourceType={RESOURCE_TYPE_RELEASED_FUNDS_LOCK}
			makeResourceSelector={makeReleasedFundsLockSelector}
			serverLoadingFunction={loadingActionLoadReleasedFundsLockFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function BalanceSourceTransferContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.transferUID}
			resourceType={RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER}
			makeResourceSelector={makeBalanceSourceTransferSelector}
			serverLoadingFunction={loadingActionLoadBalanceSourceTransferFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function CreditUserAccountLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.creditLogUID}
			resourceType={RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG}
			makeResourceSelector={makeCreditUserAccountLogSelector}
			serverLoadingFunction={loadingActionLoadCreditUserAccountLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function EventContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.eventUID}
			resourceType={RESOURCE_TYPE_EVENT}
			makeResourceSelector={makeEventSelector}
			serverLoadingFunction={loadingActionLoadEventFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function EventHookContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.hookUID}
			resourceType={RESOURCE_TYPE_EVENT_HOOK}
			makeResourceSelector={makeEventHookSelector}
			serverLoadingFunction={loadingActionLoadEventHookFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function NotificationContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.notificationUID}
			resourceType={RESOURCE_TYPE_NOTIFICATION}
			makeResourceSelector={makeNotificationSelector}
			serverLoadingFunction={loadingActionLoadNotificationFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ActionItemContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.itemUID}
			resourceType={RESOURCE_TYPE_ACTION_ITEM}
			makeResourceSelector={makeActionItemSelector}
			serverLoadingFunction={loadingActionLoadActionItemFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UpdateLogContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.entryUID}
			resourceType={RESOURCE_TYPE_UPDATE_LOG_ENTRY}
			makeResourceSelector={makeUpdateLogSelector}
			serverLoadingFunction={loadingActionLoadUpdateLogFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function StorageFileContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.fileUID}
			resourceType={RESOURCE_TYPE_STORAGE_FILE}
			makeResourceSelector={makeStorageFileSelector}
			serverLoadingFunction={loadingActionLoadStorageFileFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function AttachedStorageFilesContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.attachedFilesUID}
			resourceType={RESOURCE_TYPE_ATTACHED_STORAGE_FILES}
			makeResourceSelector={makeAttachedStorageFilesSelector}
			serverLoadingFunction={loadingActionLoadAttachedStorageFilesFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function SystemHistoryEntryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.entryUID}
			resourceType={RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY}
			makeResourceSelector={makeSystemHistoryEntrySelector}
			serverLoadingFunction={loadingActionLoadSystemHistoryEntryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function SnapshotContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.snapshotUID}
			resourceType={RESOURCE_TYPE_SNAPSHOT}
			makeResourceSelector={makeSnapshotSelector}
			serverLoadingFunction={loadingActionLoadSnapshotFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function IPAddressContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.ipUID}
			resourceType={RESOURCE_TYPE_IP_ADDRESS}
			makeResourceSelector={makeIPAddressSelector}
			serverLoadingFunction={loadingActionLoadIPAddressFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function KnownIPAddressContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.knownIpUID}
			resourceType={RESOURCE_TYPE_KNOWN_IP_ADDRESS}
			makeResourceSelector={makeKnownIPAddressSelector}
			serverLoadingFunction={loadingActionLoadKnownIPAddressFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function UserAgentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.userAgentUID}
			resourceType={RESOURCE_TYPE_USER_AGENT}
			makeResourceSelector={makeUserAgentSelector}
			serverLoadingFunction={loadingActionLoadUserAgentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function KnownUserAgentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.knownUserAgentUID}
			resourceType={RESOURCE_TYPE_KNOWN_USER_AGENT}
			makeResourceSelector={makeKnownUserAgentSelector}
			serverLoadingFunction={loadingActionLoadKnownUserAgentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function SystemStatsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.statsUID}
			resourceType={RESOURCE_TYPE_SYSTEM_STATS}
			makeResourceSelector={makeSystemStatsSelector}
			serverLoadingFunction={loadingActionLoadSystemStatsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function ResourceNoteContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.notesUID}
			resourceType={RESOURCE_TYPE_RESOURCE_NOTE}
			makeResourceSelector={makeResourceNoteSelector}
			serverLoadingFunction={loadingActionLoadResourceNoteFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function DeposifyTagContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.tagUID}
			resourceType={RESOURCE_TYPE_DEPOSIFY_TAG}
			makeResourceSelector={makeDeposifyTagSelector}
			serverLoadingFunction={loadingActionLoadDeposifyTagFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function PermanentLinkContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.linkUID}
			resourceType={RESOURCE_TYPE_PERMANENT_LINK}
			makeResourceSelector={makePermanentLinkSelector}
			serverLoadingFunction={loadingActionLoadPermanentLinkFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function OnlineUserContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.onlineUserUID}
			resourceType={RESOURCE_TYPE_ONLINE_USER}
			makeResourceSelector={makeOnlineUserSelector}
			serverLoadingFunction={loadingActionLoadOnlineUserFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function FrontendGeneralSettingsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.settingsUID}
			resourceType={RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS}
			makeResourceSelector={makeFrontendGeneralSettingsSelector}
			serverLoadingFunction={loadingActionLoadFrontendGeneralSettingsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiScreeningWorksProXMLContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.xmlUID}
			resourceType={RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML}
			makeResourceSelector={makeYardiScreeningWorksProXMLSelector}
			serverLoadingFunction={loadingActionLoadYardiScreeningWorksProXMLFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerXMLContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.voyagerXmlUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_XML}
			makeResourceSelector={makeYardiVoyagerXMLSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerXMLFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerTransactionContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.voyagerTransactionUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION}
			makeResourceSelector={makeYardiVoyagerTransactionSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerTransactionFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerResidentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.voyagerResidentUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT}
			makeResourceSelector={makeYardiVoyagerResidentSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerResidentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerResidentCustomColumnContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.customColumnUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN}
			makeResourceSelector={makeYardiVoyagerResidentCustomColumnSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerResidentCustomColumnFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPropertyUnitContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.voyagerPropertyUnitUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT}
			makeResourceSelector={makeYardiVoyagerPropertyUnitSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPropertyUnitFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPropertyContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.voyagerPropertyUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY}
			makeResourceSelector={makeYardiVoyagerPropertySelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPropertyFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPMCServiceInterfaceVersionContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.serviceInterfaceVersionUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION}
			makeResourceSelector={makeYardiVoyagerPMCServiceInterfaceVersionSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPMCServiceInterfaceVersionFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPMCContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.deposifyPmcAccountUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC}
			makeResourceSelector={makeYardiVoyagerPMCSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPMCFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPMCCredentialsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.deposifyPmcAccountUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS}
			makeResourceSelector={makeYardiVoyagerPMCCredentialsSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPMCCredentialsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPetContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.petUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PET}
			makeResourceSelector={makeYardiVoyagerPetSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPetFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerILSGuestCardEventContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.guestCardEventUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT}
			makeResourceSelector={makeYardiVoyagerILSGuestCardEventSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerILSGuestCardEventFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerChargeContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.voyagerChargeUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_CHARGE}
			makeResourceSelector={makeYardiVoyagerChargeSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerChargeFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerChargeCodeContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.chargeCodeUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE}
			makeResourceSelector={makeYardiVoyagerChargeCodeSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerChargeCodeFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerDepositCreateIntentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.createIntentUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT}
			makeResourceSelector={makeYardiVoyagerDepositCreateIntentSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerDepositCreateIntentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerDepositCloseIntentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.closeIntentUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT}
			makeResourceSelector={makeYardiVoyagerDepositCloseIntentSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerDepositCloseIntentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerDepositWithholdIntentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.withholdIntentUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT}
			makeResourceSelector={makeYardiVoyagerDepositWithholdIntentSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerDepositWithholdIntentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerEventContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.eventUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_EVENT}
			makeResourceSelector={makeYardiVoyagerEventSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerEventFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerFlexDepositIntentContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.flexIntentUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT}
			makeResourceSelector={makeYardiVoyagerFlexDepositIntentSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerFlexDepositIntentFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPhoneContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.phoneUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PHONE}
			makeResourceSelector={makeYardiVoyagerPhoneSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPhoneFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerOtherOccupantContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.otherOccupantUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT}
			makeResourceSelector={makeYardiVoyagerOtherOccupantSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerOtherOccupantFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPMCCustomColumnSettingsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.columnUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS}
			makeResourceSelector={makeYardiVoyagerPMCCustomColumnSettingsSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPMCCustomColumnSettingsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPMCStatsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.statsUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS}
			makeResourceSelector={makeYardiVoyagerPMCStatsSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPMCStatsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerPMCStatsCollectorContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.statsUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR}
			makeResourceSelector={makeYardiVoyagerPMCStatsCollectorSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerPMCStatsCollectorFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerActiveScanLogEntryContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.logUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY}
			makeResourceSelector={makeYardiVoyagerActiveScanLogEntrySelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerActiveScanLogEntryFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export function YardiVoyagerSystemSettingsContainer(props) {
	return (
		<GenericContainer
			resourceUID={props.settingsUID}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS}
			makeResourceSelector={makeYardiVoyagerSystemSettingsSelector}
			serverLoadingFunction={loadingActionLoadYardiVoyagerSystemSettingsFromServer}
		>
			{props.children}
		</GenericContainer>
	);
}
export const RESOURCE_TO_CONTAINER_DICT = {
	[RESOURCE_TYPE_USER_ACCOUNT]: UserAccountContainer,
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE]: UserAccountBalanceContainer,
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE]: UserAccountBalanceSourceContainer,
	[RESOURCE_TYPE_USER_HISTORY_ENTRY]: UserHistoryEntryContainer,
	[RESOURCE_TYPE_BALANCE_CHANGE_LOG]: BalanceChangeLogContainer,
	[RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT]: InternationalUserBankAccountContainer,
	[RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT]: USDomesticUserBankAccountContainer,
	[RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA]: UserBankAccountDeltaContainer,
	[RESOURCE_TYPE_USER_ACCOUNT_SETTINGS]: UserAccountSettingsContainer,
	[RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST]: AdminGhostUserAccountContainer,
	[RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION]: UserAccountFinalizationContainer,
	[RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING]: ThirdPartyUserAccountMappingContainer,
	[RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS]: PreviousEmailAddressContainer,
	[RESOURCE_TYPE_PENDING_EMAIL_CHANGE]: PendingEmailChangeContainer,
	[RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE]: ArchivedPendingEmailChangeContainer,
	[RESOURCE_TYPE_PASSWORD]: PasswordContainer,
	[RESOURCE_TYPE_EXPIRED_PASSWORD]: ExpiredPasswordContainer,
	[RESOURCE_TYPE_PASSWORD_RESET]: PasswordResetContainer,
	[RESOURCE_TYPE_DEPOSIT]: DepositContainer,
	[RESOURCE_TYPE_DEPOSIT_INVITE]: DepositInviteContainer,
	[RESOURCE_TYPE_DEPOSIT_ADJUSTMENT]: DepositAdjustmentContainer,
	[RESOURCE_TYPE_DEPOSIT_INTEREST]: DepositInterestContainer,
	[RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY]: DepositHistoryEntryContainer,
	[RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST]: DepositCloseRequestContainer,
	[RESOURCE_TYPE_DEPOSIT_USER_STATS]: DepositUserStatsContainer,
	[RESOURCE_TYPE_DEPOSIT_BANK_MAPPING]: DepositBankMappingContainer,
	[RESOURCE_TYPE_DEPOSITS_BULK_IMPORT]: DepositBulkImportContainer,
	[RESOURCE_TYPE_DEPOSIT_INTEREST_LOG]: DepositInterestLogContainer,
	[RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST]: ArchivedDepositCloseRequestContainer,
	[RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS]: DepositWithheldFundsContainer,
	[RESOURCE_TYPE_PMC_REPORT_TIMETABLE]: PMCReportTimetableContainer,
	[RESOURCE_TYPE_DEPOSIT_GROUP]: DepositGroupContainer,
	[RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT]: DepositPostCloseAdjustmentContainer,
	[RESOURCE_TYPE_DEPOSIT_USER_GROUP]: DepositUserGroupContainer,
	[RESOURCE_TYPE_PROPERTY_GROUP]: PropertyGroupContainer,
	[RESOURCE_TYPE_PROPERTY_USER_GROUP]: PropertyUserGroupContainer,
	[RESOURCE_TYPE_DISPUTE]: DisputeContainer,
	[RESOURCE_TYPE_DISPUTE_SPLIT]: DisputeSplitContainer,
	[RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST]: DisputeInterventionRequestContainer,
	[RESOURCE_TYPE_PROPERTY]: PropertyContainer,
	[RESOURCE_TYPE_PROPERTY_ADDRESS]: PropertyAddressContainer,
	[RESOURCE_TYPE_COMPLIANCE]: ComplianceContainer,
	[RESOURCE_TYPE_COMPLIANCE_RULE]: ComplianceRuleContainer,
	[RESOURCE_TYPE_COMPLIANCE_HISTORY]: ComplianceHistoryContainer,
	[RESOURCE_TYPE_EMAIL_TEMPLATE]: EmailTemplateContainer,
	[RESOURCE_TYPE_EMAIL_VERIFICATION]: EmailVerificationContainer,
	[RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD]: EmailVerificationRecordContainer,
	[RESOURCE_TYPE_EMAIL_EVENT]: EmailEventContainer,
	[RESOURCE_TYPE_SENT_EMAIL]: SentEmailContainer,
	[RESOURCE_TYPE_MAILBOX]: MailboxContainer,
	[RESOURCE_TYPE_MAILBOX_META_DATA]: MailboxMetaDataContainer,
	[RESOURCE_TYPE_MAILBOX_MESSAGE]: MailboxMessageContainer,
	[RESOURCE_TYPE_PERMISSION_ENTRY]: PermissionEntryContainer,
	[RESOURCE_TYPE_PERMISSION_LOG_ENTRY]: PermissionLogEntryContainer,
	[RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS]: PermissionsOrganizationSettingsContainer,
	[RESOURCE_TYPE_RESOURCE_PERMISSIONS]: ResourcePermissionContainer,
	[RESOURCE_TYPE_ORGANIZATION]: OrganizationContainer,
	[RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE]: OrganizationResourcePermissionRuleContainer,
	[RESOURCE_TYPE_INVOICE]: InvoiceContainer,
	[RESOURCE_TYPE_INVOICE_ITEM]: InvoiceItemContainer,
	[RESOURCE_TYPE_PAYMENT_REQUEST]: PaymentRequestContainer,
	[RESOURCE_TYPE_STRIPE_PAYMENT_LOG]: StripePaymentLogContainer,
	[RESOURCE_TYPE_USER_WITHDRAW]: UserWithdrawContainer,
	[RESOURCE_TYPE_PRIORITY_ACH_PAYMENT]: PriorityACHPaymentContainer,
	[RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT]: PriorityACHRecurringPaymentContainer,
	[RESOURCE_TYPE_LOAN_APPLICATION]: LoanApplicationContainer,
	[RESOURCE_TYPE_LOAN_SYSTEM_INFO]: LoanSystemInfoContainer,
	[RESOURCE_TYPE_LOAN]: LoanContainer,
	[RESOURCE_TYPE_LOAN_HISTORY]: LoanHistoryContainer,
	[RESOURCE_TYPE_LOAN_PAYMENT_LOG]: LoanPaymentLogContainer,
	[RESOURCE_TYPE_STRIPE_WEBHOOK_LOG]: StripeWebhookLogContainer,
	[RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO]: UserAccountPaymentProviderInfoContainer,
	[RESOURCE_TYPE_SEZZLE_ORDER]: SezzleOrderContainer,
	[RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT]: SezzleWebhookEventContainer,
	[RESOURCE_TYPE_BANK_ACCOUNT]: BankAccountContainer,
	[RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE]: BankAccountHistoricalInterestRateContainer,
	[RESOURCE_TYPE_BANK_ACCOUNT_INTEREST]: BankAccountInterestContainer,
	[RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD]: BankAccountBalanceRecordContainer,
	[RESOURCE_TYPE_BANK_TRANSFER]: BankTransferContainer,
	[RESOURCE_TYPE_BULK_FUNDS_TRANSFER]: BulkFundsTransferContainer,
	[RESOURCE_TYPE_FUNDS_LOCK]: FundsLockContainer,
	[RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG]: FundsLockReleaseLogContainer,
	[RESOURCE_TYPE_RELEASED_FUNDS_LOCK]: ReleasedFundsLockContainer,
	[RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER]: BalanceSourceTransferContainer,
	[RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG]: CreditUserAccountLogContainer,
	[RESOURCE_TYPE_EVENT]: EventContainer,
	[RESOURCE_TYPE_EVENT_HOOK]: EventHookContainer,
	[RESOURCE_TYPE_NOTIFICATION]: NotificationContainer,
	[RESOURCE_TYPE_ACTION_ITEM]: ActionItemContainer,
	[RESOURCE_TYPE_UPDATE_LOG_ENTRY]: UpdateLogContainer,
	[RESOURCE_TYPE_STORAGE_FILE]: StorageFileContainer,
	[RESOURCE_TYPE_ATTACHED_STORAGE_FILES]: AttachedStorageFilesContainer,
	[RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY]: SystemHistoryEntryContainer,
	[RESOURCE_TYPE_SNAPSHOT]: SnapshotContainer,
	[RESOURCE_TYPE_IP_ADDRESS]: IPAddressContainer,
	[RESOURCE_TYPE_KNOWN_IP_ADDRESS]: KnownIPAddressContainer,
	[RESOURCE_TYPE_USER_AGENT]: UserAgentContainer,
	[RESOURCE_TYPE_KNOWN_USER_AGENT]: KnownUserAgentContainer,
	[RESOURCE_TYPE_SYSTEM_STATS]: SystemStatsContainer,
	[RESOURCE_TYPE_RESOURCE_NOTE]: ResourceNoteContainer,
	[RESOURCE_TYPE_DEPOSIFY_TAG]: DeposifyTagContainer,
	[RESOURCE_TYPE_PERMANENT_LINK]: PermanentLinkContainer,
	[RESOURCE_TYPE_ONLINE_USER]: OnlineUserContainer,
	[RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS]: FrontendGeneralSettingsContainer,
	[RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML]: YardiScreeningWorksProXMLContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_XML]: YardiVoyagerXMLContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION]: YardiVoyagerTransactionContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT]: YardiVoyagerResidentContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN]: YardiVoyagerResidentCustomColumnContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT]: YardiVoyagerPropertyUnitContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY]: YardiVoyagerPropertyContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION]: YardiVoyagerPMCServiceInterfaceVersionContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC]: YardiVoyagerPMCContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS]: YardiVoyagerPMCCredentialsContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PET]: YardiVoyagerPetContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT]: YardiVoyagerILSGuestCardEventContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE]: YardiVoyagerChargeContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE]: YardiVoyagerChargeCodeContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT]: YardiVoyagerDepositCreateIntentContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT]: YardiVoyagerDepositCloseIntentContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT]: YardiVoyagerDepositWithholdIntentContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_EVENT]: YardiVoyagerEventContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT]: YardiVoyagerFlexDepositIntentContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PHONE]: YardiVoyagerPhoneContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT]: YardiVoyagerOtherOccupantContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS]: YardiVoyagerPMCCustomColumnSettingsContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS]: YardiVoyagerPMCStatsContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR]: YardiVoyagerPMCStatsCollectorContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY]: YardiVoyagerActiveScanLogEntryContainer,
	[RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS]: YardiVoyagerSystemSettingsContainer,
};

export function getResourceContainer(resourceType){
	return RESOURCE_TO_CONTAINER_DICT[resourceType];
}

